import storeCardService from "@/services/storecard.service";

const state = {
  storecards: [],
};

const mutations = {
  setStorecards(state, storecards) {
    state.storecards = storecards;
  },
  addStorecard(state, storecard) {
    state.storecards.push(storecard);
  },
  updateStorecard(state, updatedStorecard) {
    const index = state.storecards.findIndex(storecard => storecard.ID === updatedStorecard.ID);
    if (index !== -1) {
      state.storecards.splice(index, 1, updatedStorecard);
    }
  }
};

const actions = {
  loadStorecards({ commit }) {
    return storeCardService.getAll()
      .then(storecards => {
         // Sort storecards by CreatedAt$DATE
        storecards.sort((a, b) => new Date(b.CreatedAt$DATE) - new Date(a.CreatedAt$DATE));
        commit('setStorecards', storecards);
        console.log('Storecards loaded:', storecards);
      })
      .catch(error => {
        console.error('Error loading storecards:', error);
      });
  },
  createStorecard({ commit }, storecard) {
    return storeCardService.create(storecard)
      .then(newStorecard => {
        commit('addStorecard', newStorecard);
      })
      .catch(error => {
        console.error('Error creating storecard:', error);
      });
  },
  updateStorecard({ commit }, storecard) {
    return storeCardService.update(storecard.ID, storecard)
      .then(updatedStorecard => {
        commit('updateStorecard', updatedStorecard);
      })
      .catch(error => {
        console.error('Error updating storecard:', error);
      });
  }
};

const getters = {
  storecards: state => state.storecards,
};

export const storecards = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};